import { Flex } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"

const EmployeeSalaryTable = ({
  isLoading = true,
  pagination = {},
  isVisible = false,
  dataSource = [],
  onChange = () => { },
  onRowClick = () => { },
  onRowDelete = () => { },
}) => {
  const { t, i18n } = useTranslation();

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const renderOldOrNewAmount = (record, type) => {
    let valueShow;
    if (type === "OLD") {
      if (typeof record?.oldData === 'string') {
        valueShow = record?.oldData;
      } else {
        valueShow = record?.oldData?.salary;
      }
    } else {
      if (typeof record?.newData === 'string') {
        valueShow = record?.newData;
      } else {
        valueShow = record?.newData?.salary;
      }
    }
    return valueShow
  }

  const columns = [
    {
      title: <div className="text-table">{t("salary.label.effective_date")}</div>,
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      align: "center",
      render: (_, record) => {
        return (
          <div>
            {formatDate(record?.effectiveDate)}
          </div>
        );
      },
    },
    {
      title: <div className="text-table">{t('employment.label.movement_type')}</div>,
      dataIndex: "movementType",
      key: "movementType",
      render: (_, record) => {
        return <div >
          {i18n.language === "en" ? record?.movementTypeNameEN : record?.movementTypeName}
        </div>
      }
    },
    // {
    //   title: <div className="text-table">{t('employment.label.movement_type_group')}</div>,
    //   dataIndex: "movementTypeGroup",
    //   key: "movementTypeGroup",
    //   render: (_, record) => {
    //     return <div onClick={() => onRowClick(record, "modifiedBy")}>{i18n.language === "en" ? record?.movementTopicNameEn : record?.movementTopicName}</div>
    //   }
    // },
    {
      title: <div className="text-table">{t("salary.label.previous_salary")}</div>,
      dataIndex: "oldDataSalary",
      key: "oldDataSalary",
      render: (text, record) => renderOldOrNewAmount(record, "OLD")
    },
    {
      title: <div className="text-table">{t("salary.label.current_salary")}</div>,
      dataIndex: "newDataSalary",
      key: "newDataSalary",
      render: (text, record) => renderOldOrNewAmount(record, "NEW")

    },
    // {
    //   title: <div className="text-table">{t("salary.label.change")}</div>,
    //   dataIndex: "change",
    //   key: "change",
    //   render: (text, record) => {
    //     if (record?.oldData?.salary && record?.newData?.salary) {
    //       const newSalaryStr = record?.newData?.salary;
    //       const oldSalaryStr = record?.oldData?.salary;

    //       const newSalary = parseFloat(newSalaryStr.replace(/,/g, ''));
    //       const oldSalary = parseFloat(oldSalaryStr.replace(/,/g, ''));

    //       if (oldSalary !== 0) {
    //         const change = ((newSalary - oldSalary) / oldSalary) * 100;

    //         return (
    //           <div onClick={() => onRowClick(record, "change")}>
    //             {isVisible ? change.toFixed(2) + "%" : 'xxxx.xx%'}
    //           </div>
    //         );
    //       } else {
    //         return (
    //           <div onClick={() => onRowClick(record, "change")}>
    //             {"-"}
    //           </div>
    //         );
    //       }
    //     }

    //     // กรณีที่ไม่มีข้อมูล salary ที่เพียงพอ แสดงผลเป็น "-"
    //     return (
    //       <div onClick={() => onRowClick(record, "change")}>
    //         {"-"}
    //       </div>
    //     );
    //   },
    // },
    {
      title: <div className="text-table">{t("salary.label.remark")}</div>,
      dataIndex: "remark",
      key: "remark",
      render: (text, record) => (
        <div >
          {record?.remark || "-"}
        </div>
      ),
    },
    {
      title: <div className="text-table">{t('employment.label.last_modified')}</div>,
      dataIndex: "modifiedBy",
      key: "modifiedBy",
      render: (_, record) => {
        // console.log("record", record);
        const lastModified = record.createBy;
        const name = i18n.language === "en" ? lastModified?.nameAndSurnameEn : lastModified?.nameAndSurname;

        const formatThaiDateTime = (date) => {
          if (!date) return "-";
          const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          };
          return new Date(date).toLocaleDateString("th-TH", options);
        };

        return (
          <div >
            <Flex vertical>
              {name}
              <br />
              {record.createDate ? formatThaiDateTime(record.createDate) : "-"}
            </Flex>
          </div>
        );
      },
    },
    {
      title: <div className="text-table">{t("employee.label.status")}</div>,
      dataIndex: "employeeStatus",
      key: "employeeStatus",
      // sorter: true,
      width: 160,
      align: "center",
      render: (_, record) => {
        let language = i18n.language === 'en' ? "En" : ""
        return (
          record?.approveStatus ?
            <StatusTag
              value={record?.approveStatus}
              text={(record?.["approveStatus" + language])} /> : "-"
        )
      },
    },

    // {
    //   title: <div className="text-table">{t('action.action')}</div>,
    //   key: "action",
    //   align: "center",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <DeleteOutlined onClick={() => onRowDelete(record.id)} />
    //     </Space>
    //   ),
    // },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      // pagination={null}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    // onColum={{}}
    />
  );
};

export default EmployeeSalaryTable;
